import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { 
  NavBar, 
  Tabbar, 
  TabbarItem, 
  Field, 
  Cell, 
  CellGroup, 
  Button,
  DatetimePicker,
  Popup,
  Toast,
  Form,
  Icon,
  Dialog,
  Radio,
  RadioGroup
} from 'vant'
import 'vant/lib/index.css'
import './assets/tailwind.css'

Vue.use(NavBar)
Vue.use(Tabbar)
Vue.use(TabbarItem)
Vue.use(Field)
Vue.use(Cell)
Vue.use(CellGroup)
Vue.use(Button)
Vue.use(DatetimePicker)
Vue.use(Popup)
Vue.use(Toast)
Vue.use(Form)
Vue.use(Icon)
Vue.use(Radio)
Vue.use(RadioGroup)
Vue.use(Dialog)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
